import api from "../api/flexapi";
export const FETCH_ENROLLMENT_SETTINGS_BEGIN = "FETCH_ENROLLMENT_SETTINGS_BEGIN";
export const FETCH_ENROLLMENT_SETTINGS_SUCCESS = "FETCH_ENROLLMENT_SETTINGS_SUCCESS";
export const FETCH_ENROLLMENT_SETTINGS_ERROR = "FETCH_ENROLLMENT_SETTINGS_ERROR";

export const FETCH_ENROLLMENT_DETAILS_BEGIN = "FETCH_ENROLLMENT_DETAILS_BEGIN";
export const FETCH_ENROLLMENT_DETAILS_SUCCESS = "FETCH_ENROLLMENT_DETAILS_SUCCESS";
export const FETCH_ENROLLMENT_DETAILS_ERROR = "FETCH_ENROLLMENT_DETAILS_ERROR";

export const SAVE_ENROLLMENT_BEGIN = "SAVE_ENROLLMENT_BEGIN";
export const SAVE_ENROLLMENT_SUCCESS = "SAVE_ENROLLMENT_SUCCESS";
export const SAVE_ENROLLMENT_ERROR = "SAVE_ENROLLMENT_ERROR";

export const FETCH_ENROLLMENT_PREVIEW_BEGIN = "FETCH_ENROLLMENT_PREVIEW_BEGIN";
export const FETCH_ENROLLMENT_PREVIEW_SUCCESS = "FETCH_ENROLLMENT_PREVIEW_SUCCESS";
export const FETCH_ENROLLMENT_PREVIEW_ERROR = "FETCH_ENROLLMENT_PREVIEW_ERROR";
export const CHANGE_PLAN = "CHANGE_PLAN";
export const CHANGE_INTERVAL_OPTION = "CHANGE_INTERVAL_OPTION";
export const CHANGE_MEMBER_SELECTION = "CHANGE_MEMBER_SELECTION";
export const CHANGE_MEMBER_GROUP = "CHANGE_MEMBER_GROUP";

export const TOGGLE_SHOW_MORE = "TOGGLE_SHOW_MORE";
export const TOGGLE_PANEL = "TOGGLE_PANEL";

export const CHECKOUT_ENROLLMENT_BEGIN = "CHECKOUT_ENROLLMENT_BEGIN";
export const CHECKOUT_ENROLLMENT_SUCCESS = "CHECKOUT_ENROLLMENT_SUCCESS";
export const CHECKOUT_ENROLLMENT_ERROR = "CHECKOUT_ENROLLMENT_ERROR";

export const VALIDATE_ENROLLMENT_BEGIN = "VALIDATE_ENROLLMENT_BEGIN";
export const VALIDATE_ENROLLMENT_SUCCESS = "VALIDATE_ENROLLMENT_SUCCESS";
export const VALIDATE_ENROLLMENT_ERROR = "VALIDATE_ENROLLMENT_ERROR";
export const CLEAR_ENROLLMENT_ERROR = "CLEAR_ENROLLMENT_ERROR";

export const getEnrolmentSettings = () => dispatch => {
  dispatch({ type: FETCH_ENROLLMENT_SETTINGS_BEGIN, payload: null });
  api
    .getEnrolmentSettings()
    .then(res => {
      dispatch({
        type: FETCH_ENROLLMENT_SETTINGS_SUCCESS,
        payload: res.body,
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_ENROLLMENT_SETTINGS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};
export const getEnrolmentBenefits = benefitType => dispatch => {
  dispatch({ type: FETCH_ENROLLMENT_DETAILS_BEGIN });
  api
    .getEnrolmentBenefits(benefitType)
    .then(res => {
      dispatch({
        type: FETCH_ENROLLMENT_DETAILS_SUCCESS,
        payload: res.body,
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_ENROLLMENT_DETAILS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const changePlan = (benefit, plan) => dispatch => {
  dispatch({
    type: CHANGE_PLAN,
    payload: { benefitID: benefit.benefitID, selectedPlan: plan },
  });
};

export const changeIntervalOption = (plan, benefitId, optionId) => dispatch => {
  dispatch({
    type: CHANGE_INTERVAL_OPTION,
    payload: { plan, benefitId, optionId },
  });
};

export const changeMemberSelection = (plan, benefitId, memberKey, memberType) => dispatch => {
  dispatch({
    type: CHANGE_MEMBER_SELECTION,
    payload: { plan, benefitId, memberKey ,memberType},
  });
};

export const changeMemberGroup = (plan, benefitId, memberType) => dispatch => {
  dispatch({
    type: CHANGE_MEMBER_GROUP,
    payload: { plan, benefitId, memberType },
  });
};

export const saveEnrolmentBenefits = (data, callback) => dispatch => {
  dispatch({ type: SAVE_ENROLLMENT_BEGIN });
  api
    .saveEnrolmentSelection(data)
    .then(res => {
      dispatch({
        type: SAVE_ENROLLMENT_SUCCESS,
        payload: res.body,
      });
      callback && callback();
    })
    .catch(err => {
      dispatch({
        type: SAVE_ENROLLMENT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getEnrolmentCheckoutPreview = () => dispatch => {
  dispatch({ type: FETCH_ENROLLMENT_PREVIEW_BEGIN });
  api
    .getEnrolmentCheckoutPreview()
    .then(res => {
      dispatch({
        type: FETCH_ENROLLMENT_PREVIEW_SUCCESS,
        payload: res.body,
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_ENROLLMENT_PREVIEW_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const checkout = (
  hasAgreed = false,
  salaryDeductionAgreed = false,
  callBack
) => dispatch => {
  dispatch({ type: CHECKOUT_ENROLLMENT_BEGIN });
  api
    .checkoutEnrolment(hasAgreed, salaryDeductionAgreed)
    .then(res => {
      dispatch({
        type: CHECKOUT_ENROLLMENT_SUCCESS,
        payload: res.body,
      });
      callBack && callBack();
    })
    .catch(err => {
      dispatch({
        type: CHECKOUT_ENROLLMENT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const togglePanel = benefitId => dispatch => {
  dispatch({
    type: TOGGLE_PANEL,
    payload: benefitId,
  });
};
export const toggleShowMore = benefitId => dispatch => {
  dispatch({
    type: TOGGLE_SHOW_MORE,
    payload: benefitId,
  });
};
export const validateEnrolmentSelection = (data, callback) => dispatch => {
  dispatch({ type: VALIDATE_ENROLLMENT_BEGIN });
  api
    .validateEnrolmentSelection(data)
    .then(res => {
      dispatch({
        type: VALIDATE_ENROLLMENT_SUCCESS,
      });
      callback && callback();
    })
    .catch(err => {
      dispatch({
        type: VALIDATE_ENROLLMENT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const clearError = () => dispatch => {
  dispatch({
    type: CLEAR_ENROLLMENT_ERROR,
  });
};



// WEBPACK FOOTER //
// ./actions/enrollmentActions.js